import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  userID,
  clientID,
  CompanyID,
  isEmpty,
  isEmail,
  isPhone,
  isNumber,
  isSingleSelect,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
import PageLoader from "../../Helpers/PageLoader";
var module = "outlet";
var moduleName = "Outlet";
var modulePath = "/clientpanel/outlet";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/outlet/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      clientdata: {
        outletName: "",
        outletPOSID: "",
        outletEmail: "",
        outletPhone: "",
        outletPostalCode: "",
        outletUnitNumber: "",
        outletFloorNumber: "",
        outletAddress: "",
        outletLatitude: "",
        outletLongitude: "",
        outletStatus: "",
        outletPerdayLimit: "",
        outletInformation: "",
        outletSequence: "",
        outletMapLink: "",
        outletTimeInfo: "",
        outletOfferInfo: "",
        outletImage: "",
        outletAvailability: [],
        outletDeliveryTAT: "",
        outletPickupTAT: "",
        outletDineInTAT:"",
        outletTagID: "",
        action: "add",
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      availabiltyList: [],
      outlet_availability: [],
      formpost: [],
      companyDetail: [],
      tagList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadTATList();
    this.loadAvailabilty();
    this.loadOutletTag();

    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var outletAvailability = result?.outletAvailability ?? [];
          var outletTagID = result?.outletTagID ?? [];
          var outletDeliveryTAT =
            result.outletDeliveryTAT !== "" &&
            result.outletDeliveryTAT !== null
              ? {
                  label: result.outletDeliveryTAT,
                  value: result.outletDeliveryTAT,
                }
              : "";
          var outletPickupTAT =
            result.outletPickupTAT !== "" && result.outletPickupTAT !== null
              ? {
                  label: result.outletPickupTAT,
                  value: result.outletPickupTAT,
                }
              : "";
          var outletDineInTAT =
              result.outletDineInTAT !== "" && result.outletDineInTAT !== null
                ? {
                    label: result.outletDineInTAT,
                    value: result.outletDineInTAT,
                  }
                : "";
              
          var outletStatus = result.outletStatus === 1 ? "Open" : "Closed";
          var status =
            result.outletStatus !== "" &&
            result.outletStatus !== null
              ? {
                  label: outletStatus,
                  value: result.outletStatus,
                }
              : "";

          var clientupdatedata = {
            outletName: result.outletName,
            outletPOSID: result.outletPOSID,
            outletEmail: result.outletEmail,
            outletPhone: result.outletPhone,
            outletPostalCode: result.outletPostalCode,
            outletUnitNumber: result.outletUnitNumber,
            outletFloorNumber: result.outletFloorNumber,
            outletAddress: result.outletAddress,
            outletLatitude: result.outletLatitude,
            outletLongitude: result.outletLongitude,
            outletStatus: status,
            outletSequence: result.outletSequence,
            outletPerdayLimit: result.outletPerdayLimit,
            outletAvailability:outletAvailability,
            outletInformation: result.outletInformation !== "" && result.outletInformation !== null ? result.outletInformation : "",
            outletMapLink: result.outletMapLink,
            outletTimeInfo: result.outletTimeInfo,
            outletOfferInfo: result.outletOfferInfo,
            outletDeliveryTAT: outletDeliveryTAT,
            outletPickupTAT: outletPickupTAT,
            outletDineInTAT:outletDineInTAT,
            outletImage:
              result.outletImage !== "" && result.outletImage !== null
                ? result.outletImage
                : "",
                outletTagID:outletTagID,
            
            action: "edit",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid " + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };
  loadTATList() {
    var urlShringTxt = apiUrl + "common/getTATList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      var tatList = [];
      if (res.data.status === "ok") {
        res.data.result.forEach(item => tatList.push({ label: item, value: item }));
      }
      this.setState({ tatList: tatList });
    }).catch((e) => {
      console.log(e)
    });
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";

    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadOutletTag() {
    var urlShringTxt =
      apiUrl + "outlettag/dropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ tagList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }

  handleChange(checked, name) {
    this.setState({ checked });
  }

  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { clientdata: { [field]: { $set: value } } }), () => {
        if(field==='outletPostalCode') {
          if(value.length===6) {
            this.getAddress(value);
          }          
        }
      }
    );
  };

  getAddress(zipcode) {
    const postObject = {
      zipcode:zipcode
    }
    axios.post(apiUrl + "common/zipCode", postObject, {
      headers: { Authorization: `Bearer ${localStorage.getItem("clientAccessToken")}` },
    }).then((res) => {
      if(res.data.status==='ok') {
        var result = res.data.result;
        this.setState(
          update(this.state, { clientdata: { outletUnitNumber: { $set: result.zip_buno }, outletAddress: { $set: result.zip_sname }, outletLatitude: { $set: result.zip_latitude }, outletLongitude: { $set: result.zip_longitude } } })
        );
      }
    }).catch((e)=> {
      console.log(e)
    });
  }

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var outletAvailability = postData.outletAvailability.length > 0 ? postData.outletAvailability.map(item => item.value) : [];
    var outletTagID = postData.outletTagID.length > 0 ? postData.outletTagID.map(item => item.value) : [];
    

    var postObject = {
      outletName: postData.outletName,
      outletPOSID: postData.outletPOSID,
      outletEmail: postData.outletEmail,
      outletPhone: postData.outletPhone,
      outletPostalCode: postData.outletPostalCode,
      outletUnitNumber: postData.outletUnitNumber,
      outletFloorNumber: postData.outletFloorNumber,
      outletAddress: postData.outletAddress,
      outletLatitude: postData.outletLatitude,
      outletLongitude: postData.outletLongitude,
      outletStatus: postData.outletStatus?.value ?? 0,
      outletSequence: postData.outletSequence,
      outletPerdayLimit: postData.outletPerdayLimit,
      outletInformation: postData.outletInformation,
      outletMapLink: postData.outletMapLink,
      outletTimeInfo: postData.outletTimeInfo,
      outletOfferInfo: postData.outletOfferInfo,
      outletImage: postData.outletImage,
      outletDeliveryTAT: postData?.outletDeliveryTAT?.value ?? "",
      outletPickupTAT: postData?.outletPickupTAT?.value,
      outletDineInTAT: postData?.outletDineInTAT?.value,
      outletAvailability: outletAvailability.length > 0 ? outletAvailability.join(",") : "",
      outletTagID: outletTagID.length > 0 ? outletTagID.join(",") : "",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
   
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"outlet"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} Outlet
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Postform
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  tatList={this.state.tatList}
                  availabiltyList={this.state.availabiltyList}
                  tagList={this.state.tagList}
                  onInvalid={() => {
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 160,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    outletName,
    outletEmail,
    outletPhone,
    outletPostalCode,
    outletUnitNumber,
    outletAddress,  
    outletStatus
  } = props.fields;

  return {
    fields: [
      "outletName",
      "outletEmail",
      "outletPhone",
      "outletPostalCode",
      "outletUnitNumber",
      "outletAddress",
      "outletStatus"
    ],

    validations: {
      outletName: [[isEmpty, outletName]],
      outletEmail: [
        [isEmpty, outletEmail],
        [isEmail, outletEmail],
      ],
      outletPhone: [
        [isEmpty, outletPhone],
        [isPhone, outletPhone],
      ],
      outletPostalCode: [
        [isEmpty, outletPostalCode],
        [isNumber, outletPostalCode],
      ],
      outletUnitNumber: [[isEmpty, outletUnitNumber]],
      outletAddress: [[isEmpty, outletAddress]],
      outletStatus: [[isSingleSelect, outletStatus]],
    },
  };
}

class Postform extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("outletInformation", value);
  }
  async uplaodoutletImage() {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#outletImage");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "outlet", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange("outletImage", fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#outletImage").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, ImageType, event) {
    event.preventDefault();

    var imagePath = "";
    if (ImageType === "outletImage") {
      imagePath = "ImageDetails";
    }
    if (imagePath !== "") {
      showLoader(imagePath);
    }

    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      if (imagePath !== "") {
        hideLoader(imagePath);
      }
      this.props.onChange(ImageType, "");
    }
  }

  sateValChange = (field, value) => {
    if (field === "btndisabled") {
      this.setState({ btndisabled: value });
    }
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgOutletName,
      errMssEmail,
      errMsgPhone,
      errMsgoutletUnitNumber,
      errMsgAddress,
      errMsgPostalCode,
      errMsgStatus = "";
    
    if ($validation.outletName.error.reason !== undefined) {
      errMsgOutletName = $validation.outletName.show && (
        <span className="error">{$validation.outletName.error.reason}</span>
      );
    }
    if ($validation.outletEmail.error.reason !== undefined) {
      errMssEmail = $validation.outletEmail.show && (
        <span className="error">{$validation.outletEmail.error.reason}</span>
      );
    }
    if ($validation.outletPhone.error.reason !== undefined) {
      errMsgPhone = $validation.outletPhone.show && (
        <span className="error">{$validation.outletPhone.error.reason}</span>
      );
    }
    if ($validation.outletPostalCode.error.reason !== undefined) {
      errMsgPostalCode = $validation.outletPostalCode.show && (
        <span className="error">
          {$validation.outletPostalCode.error.reason}
        </span>
      );
    }
    if ($validation.outletUnitNumber.error.reason !== undefined) {
      errMsgoutletUnitNumber = $validation.outletUnitNumber.show && (
        <span className="error">{$validation.outletUnitNumber.error.reason}</span>
      );
    }

    if ($validation.outletAddress.error.reason !== undefined) {
      errMsgAddress = $validation.outletAddress.show && (
        <span className="error">
          {$validation.outletAddress.error.reason}
        </span>
      );
    } 

    if ($validation.outletStatus.error.reason !== undefined) {
      errMsgStatus = $validation.outletStatus.show && (
        <span className="error">{$validation.outletStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 pt-5">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgOutletName !== "" &&
                  errMsgOutletName !== false &&
                  errMsgOutletName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="outletName"
                value={fields.outletName}
                {...$field("outletName", (e) =>
                  onChange("outletName", e.target.value)
                )}
              />
              <label htmlFor="outletName">
                Outlet Name <span className="error">*</span>
              </label>
              {errMsgOutletName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletPOSID"
                value={fields.outletPOSID}
                {...$field("outletPOSID", (e) =>
                  onChange("outletPOSID", e.target.value)
                )}
              />
              <label htmlFor="outletPOSID">POS ID</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMssEmail !== "" &&
                  errMssEmail !== false &&
                  errMssEmail !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="outletEmail"
                id="outletEmail"
                value={fields.outletEmail}
                {...$field("outletEmail", (e) =>
                  onChange("outletEmail", e.target.value)
                )}
              />
              <label htmlFor="outletEmail">
                Email ID <span className="error">*</span>
              </label>
              {errMssEmail}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgPhone !== "" &&
                  errMsgPhone !== false &&
                  errMsgPhone !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="outletPhone"
                id="outletPhone"
                value={fields.outletPhone}
                {...$field("outletPhone", (e) =>
                  onChange("outletPhone", e.target.value)
                )}
              />
              <label htmlFor="outletPhone">
                Phone <span className="error">*</span>
              </label>
              {errMsgPhone}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgPostalCode !== "" &&
                  errMsgPostalCode !== false &&
                  errMsgPostalCode !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="outletPostalCode"
                id="outletPostalCode"
                value={fields.outletPostalCode}
                {...$field("outletPostalCode", (e) =>
                  onChange("outletPostalCode", e.target.value)
                )}
              />
              <label htmlFor="outletPostalCode">
                Postal Code<span className="error">*</span>
              </label>
              {errMsgPostalCode}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgoutletUnitNumber !== "" &&
                  errMsgoutletUnitNumber !== false &&
                  errMsgoutletUnitNumber !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="outletUnitNumber"
                id="outletUnitNumber"
                value={fields.outletUnitNumber}
                {...$field("outletUnitNumber", (e) =>
                  onChange("outletUnitNumber", e.target.value)
                )}
              />
              <label htmlFor="outletUnitNumber">
              Unit No.<span className="error">*</span>
              </label>
              {errMsgoutletUnitNumber}
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletFloorNumber"
                id="outletFloorNumber"
                value={fields.outletFloorNumber}
                {...$field("outletFloorNumber", (e) =>
                  onChange("outletFloorNumber", e.target.value)
                )}
              />
              <label htmlFor="outletFloorNumber">
              Floor No.<span className="error">*</span>
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgAddress !== "" &&
                  errMsgAddress !== false &&
                  errMsgAddress !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="outletAddress"
                id="outletAddress"
                value={fields.outletAddress}
                {...$field("outletAddress", (e) =>
                  onChange("outletAddress", e.target.value)
                )}
              />
              <label htmlFor="outletAddress">Address Line</label>
              {errMsgAddress}
            </div>
          </div>
          {this.props.availabiltyList.length > 0 &&
            this.props.availabiltyList.map((item, index) => {
              var slectedtat = [];
              if (item.label.toLowerCase() === "delivery") {
                slectedtat = fields.outletDeliveryTAT;
              }
              if (item.label.toLowerCase() === "pickup") {
                slectedtat = fields.outletPickupTAT;
              }
              if (item.label.toLowerCase() === "dinein") {
                slectedtat = fields.outletDineInTAT;
              }
              return (
                <div className="col-md-3" key={index}>
                  <div className="form-floating form-floating-outline custm-select-box">
                    <Select
                      value={slectedtat}
                      onChange={this.handleSelectChange.bind(
                        this,
                        "outlet" + item.label + "TAT"
                      )}
                      placeholder={"Select " + item.label + " TAT"}
                      options={this.props.tatList}
                    />
                    <label className="select-box-label">
                      {item.label + " TAT"}
                    </label>
                  </div>
                </div>
              );
            })}
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletPerdayLimit"
                id="outletPerdayLimit"
                value={fields.outletPerdayLimit}
                {...$field("outletPerdayLimit", (e) =>
                  onChange("outletPerdayLimit", e.target.value)
                )}
              />
              <label htmlFor="outletPerdayLimit">Order Limit Per Day</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.outletAvailability}
                onChange={this.handleSelectChange.bind(this, "outletAvailability")}
                isMulti
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
              />
              <label className="select-box-label">Availabilty</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletSequence"
                id="outletSequence"
                value={fields.outletSequence}
                {...$field("outletSequence", (e) =>
                  onChange("outletSequence", e.target.value)
                )}
              />
              <label htmlFor="outletSequence">Sequence</label>
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mt-4">
              <Select
                value={fields.outletStatus}
                onChange={this.handleSelectChange.bind(this, "outletStatus")}
                placeholder="Select Shop Opening Status"
                options={[
                  { value: 1, label: "Open" },
                  { value: 0, label: "Closed" },
                ]}
              />
              <label className="select-box-label">
                Shop Opening Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12">
            <label>Outlet Information</label>
            <Editor
              setContent={this.setContent}
              data={fields.outletInformation}
            />
          </div>          
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletMapLink"
                id="outletMapLink"
                value={fields.outletMapLink}
                {...$field("outletMapLink", (e) =>
                  onChange("outletMapLink", e.target.value)
                )}
              />
              <label htmlFor="outletMapLink">Map Link</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletTimeInfo"
                id="outletTimeInfo"
                value={fields.outletTimeInfo}
                {...$field("outletTimeInfo", (e) =>
                  onChange("outletTimeInfo", e.target.value)
                )}
              />
              <label htmlFor="outletTimeInfo">Time Info</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="outletOfferInfo"
                id="outletOfferInfo"
                value={fields.outletOfferInfo}
                {...$field("outletOfferInfo", (e) =>
                  onChange("outletOfferInfo", e.target.value)
                )}
              />
              <label htmlFor="outletOfferInfo">Offer Info</label>
            </div>
          </div>

          <div
            className="col-md-12"
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.outletTagID}
                isMulti
                onChange={this.handleSelectChange.bind(this, "outletTagID")}
                placeholder="Select Tags"
                options={this.props.tagList}
                isClearable={true}
              />
              <label className="select-box-label">
                Tags
              </label>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Outlet Thumbnail Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="outletImage"
                  onChange={(event) => {
                    this.uplaodoutletImage(event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.outletImage !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details" id="ImageDetails">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.outletImage} />
                  </div>
                </div>
                <a
                  className="dz-remove"
                  href="/"
                  onClick={this.removeImage.bind(
                    this,
                    fields.outletImage,
                    "outletImage"
                  )}
                >
                  Remove file
                </a>
              </div>
            )}
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
Postform = validated(validationConfig)(Postform);
